export const Heading4 = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { children, className } = props;
  return (
    <h4 className={`mb-2 fw-normal${className ? ` ${className}` : ""}`}>
      {children}
    </h4>
  );
};

export const Heading5 = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { children, className } = props;
  return (
    <h5 className={`fw-normal mb-2${className ? ` ${className}` : ""}`}>
      {children}
    </h5>
  );
};
